import React from 'react';
import { useNavigate } from 'react-router-dom';
import './../../../style/MobileStyles.css';

const SISTEMA_MODULES = [
    {
        id: 'colores',
        title: 'Gestión de Colores',
        description: 'Administra los temas de color del sistema',
        icon: '🎨',
        color: 'rose',
        path: '/menu/sistema/colores'
    },
    {
        id: 'logos',
        title: 'Gestión de Logos',
        description: 'Administra logotipos, isotipos y favicon',
        icon: '🖼️',
        color: 'blue',
        path: '/menu/sistema/logos'
    },
    {
        id: 'imagenes',
        title: 'Imágenes del Sistema',
        description: 'Administra fondos, banners e imágenes core',
        icon: '🌄',
        color: 'amber',
        path: '/menu/sistema/imagenes'
    },
    {
        id: 'designer',
        title: 'Diseñador Visual',
        description: 'Diseña y previsualiza temas de forma visual',
        icon: '✨',
        color: 'indigo',
        path: '/menu/sistema/designer'
    },
    {
        id: 'importacion',
        title: 'Importación Masiva',
        description: 'Carga masiva de empleados, cursos y datos',
        icon: '📥',
        color: 'emerald',
        path: '/menu/sistema/importacion'
    }
];

export default function SistemaPanel() {
    const navigate = useNavigate();

    const handleClick = (path) => {
        navigate(path);
    };

    return (
        <div className="modules-container">
            <h1>Sistema - Configuración Core</h1>
            <div className="modules-grid">
                {SISTEMA_MODULES.map((module) => (
                    <div
                        key={module.id}
                        className={`module-card module-card--${module.color || 'slate'}`}
                        onClick={() => handleClick(module.path)}
                        role="button"
                        tabIndex={0}
                        onKeyPress={(e) => e.key === 'Enter' && handleClick(module.path)}
                    >
                        <div className="module-card__title">{module.title}</div>
                        <div className="module-card__description">{module.description}</div>
                        <div className="module-card__icon" aria-hidden="true">
                            {module.icon}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
